import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { formatDate, Location } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  calculateTimeDifference,
  getFormattedDate,
  getFormattedTime,
  getStartAndEndTime,
  getWelfareCheckInterval,
  isLargeScreen,
} from '../../../../../../global.variable';
import { AppService } from '../../../../../app.service';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../../../../../shared/components/view-user-detail/view-user-detail.component';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { CheckpointService } from '../../../checkpoints/checkpoint.service';
import { JobsService } from '../../jobs.service';
import { ClientsService } from '../../../clients/clients.service';

@Component({
  selector: 'gtapp-patrol',
  templateUrl: './patrol.component.html',
  styleUrl: './patrol.component.scss',
  standalone: false,
})
export class PatrolComponent implements OnInit {
  @Input() selectedJobType: any;

  formdata = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
    assigneeName: new UntypedFormControl(),
    patrol_brief: new UntypedFormControl(),
  });

  addJobPressed: boolean = false;
  currentStep: number = 1;
  showCheckpointList: boolean = false;
  patrolJobType: any = {
    jobType: {
      name: 'job Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    name: {
      name: 'Name',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    checkpoints: {
      name: 'Checkpoints',
      value: '',
      edit: false,
      data: [],
      tempValue: '',
    },
    patrol_brief: {
      name: 'Patrol Brief',
      value: '',
      edit: false,
      data: [],
      tempValue: '',
    },
    patrol_brief_files: {
      name: 'Patrol Brief Files',
      value: '',
      edit: false,
      data: [],
      tempValue: '',
    },
    assignees: {
      name: 'Assignee',
      value: '',
      edit: false,
      data: [],
      tempValue: '',
    },

    schedule: {
      name: 'Schedule',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
  };

  checkpointListData: any = [];

  dialogRef: any;

  schedulerForm: UntypedFormGroup = new UntypedFormGroup({
    end_time: new FormControl(null),
    start_time: new FormControl(null),
    start_day: new FormControl(new Date()),
    end_day: new FormControl(null, Validators.required),
    repeat_times: new UntypedFormControl(null),
    repeat_type: new UntypedFormControl(null, Validators.required),
    repeat_details: new UntypedFormControl([]),
    repeat_interval: new UntypedFormControl(1, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    position: new UntypedFormControl(null, []),
    week_day: new UntypedFormControl(null, []),
    month_repeat_case: new UntypedFormControl(null, []),
  });
  addSchedule: boolean = false;

  patrolRouteCPList: any = [];
  patrolRouteCpTotalCount: number = 0;

  patrolCpFilterValue: any;
  cpSiteFilter: any = {};
  patrolCPCursor: string = '';

  siteListData: any = [];
  siteListDataBackup: any = [];
  checkpointSearchTimeoutFn: any;

  assigneeList: any = [];
  assignedGuardData: any = {};

  scheduleStepperActive: boolean = false;
  intervalData: any = [
    { name: 'Disabled', value: 0 },
    { name: 'Every 15 mins', value: 15 },
    { name: 'Every 30 mins', value: 30 },
  ];
  intervalCheck: any = 0;
  welfareReminderDict: any = {};

  largeView = isLargeScreen;
  selectedLastCP: any;

  patrolRouteSuggestionsDataList: any = [];
  selectedSuggestedRoute: any = {};

  userDetailPopoverTemplate = ViewUserDetailComponent;
  lastAddedCheckpointID: string = '';
  checkpointAddedTimeoutFn: any;

  routedFromSchedule: boolean = false;

  constructor(
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private checkpointService: CheckpointService,
    private viewContainerRef: ViewContainerRef,
    private appService: AppService,
    private toasterService: ToasterService,
    private _location: Location,
  ) {}

  ngOnInit(): void {
    const lastNav = this.router?.lastSuccessfulNavigation;

    const previousUrl = lastNav?.previousNavigation?.finalUrl?.toString();
    this.routedFromSchedule = !!previousUrl?.includes('/schedule');

    this.patrolJobType.jobType.value = this.selectedJobType?.name;
    this.patrolJobType.jobType.data = this.selectedJobType;
    const schedulePrefilledData = sessionStorage.getItem(
      btoa('schedulePrefilledData'),
    );

    const rosterCopyJobInfo = JSON.parse(
      sessionStorage.getItem(btoa('rosterCopyJobInfo')) || '{}',
    );
    if (
      rosterCopyJobInfo?.id &&
      rosterCopyJobInfo?.job_type_dict?.type_identity == 4
    ) {
      this.loadSuggestedRoute(rosterCopyJobInfo);
    } else if (schedulePrefilledData) {
      const shiftData = JSON.parse(schedulePrefilledData) || {};

      this.schedulerForm.patchValue(shiftData?.schedule);
      this.saveCurrentSchedule();
      this.formdata.patchValue({
        name: shiftData?.shift?.name,
      });
      if (shiftData?.shift?.assignee_id) {
        this.assignedGuardData = {
          id: shiftData?.shift?.assignee_id,
          full_name: shiftData?.shift?.assignee_name,
        };

        this.patrolJobType.assignees.data = [
          {
            id: shiftData?.shift?.assignee_id,
            full_name: shiftData?.shift?.assignee_name,
          },
        ];
      }
      sessionStorage.removeItem(btoa('schedulePrefilledData'));
    }
    sessionStorage.removeItem(btoa('rosterCopyJobInfo'));
    this.getPatroulRouteSuggestions();
    this.editOtherJobTypeItem('name');
    this.onSiteSearch();
    this.getCheckpointsCount();
  }

  getCheckpointsCount() {
    let params: any = { get_count: 1 };

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolRouteCpTotalCount = response?.cp_count;
        }
      });
  }
  goBack() {
    this._location.back();
  }

  onAddJob() {
    this.schedulerForm.value.start_day =
      this.schedulerForm.value.start_day == ''
        ? ''
        : formatDate(this.schedulerForm.value.start_day, 'yyyy-MM-dd', 'en');
    this.schedulerForm.value.end_day =
      this.schedulerForm.value.end_day == null
        ? null
        : formatDate(this.schedulerForm.value.end_day, 'yyyy-MM-dd', 'en');
    let timezoneOffset = new Date();

    this.addJobPressed = true;
    this.spinnerService.show();
    let data: any = {
      job_type_id: this.selectedJobType.id,
      time_offset: timezoneOffset.getTimezoneOffset(),
      ...this.schedulerForm.value,
      name: this.formdata.value?.name,
      patrol_brief: this.formdata.value?.patrol_brief,
      assignees: [
        ...new Set(
          this.patrolJobType?.assignees?.data?.map(
            (assignee: any) => assignee?.id,
          ),
        ),
      ],
      checkpoints: this.patrolJobType.checkpoints?.data?.map(
        (checkpoint: any) => ({
          id: checkpoint?.id,
        }),
      ),
    };

    data['interval_check'] = this.intervalCheck || 0;

    let formData: FormData = new FormData();
    formData.append('file', this.patrolJobType.patrol_brief_files.value);
    formData.append('form_data', JSON.stringify(data));
    let params: any = {};

    this.appService
      .formDataApi('roster_shift', formData, false, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          sessionStorage.removeItem('selectedRosterDate');
          this.router.navigate(['/schedule'], {
            fragment: getFormattedDate(this.schedulerForm.value.start_day),
          });
        } else {
          this.addJobPressed = false;
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }

        this.spinnerService.hide();
      });
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'end',
      });
    }, 100);
  }
  editOtherJobTypeItem(field: string) {
    for (let key in this.patrolJobType) {
      this.patrolJobType[key]['edit'] = false;
    }
    this.patrolJobType[field]['edit'] = true;
  }
  openTemplate(template: TemplateRef<any>) {
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  ngOnDestroy() {
    sessionStorage.removeItem('schedulerData');
  }
  formatScheduleForm() {
    this.addSchedule = true;
    const currentSchedule = sessionStorage.getItem(btoa('currentSchedule'));

    if (currentSchedule) {
      this.schedulerForm.patchValue(JSON.parse(currentSchedule));
      this.scheduleStepperActive = true;
      if (!this.routedFromSchedule)
        sessionStorage.removeItem(btoa('currentSchedule'));

      return;
    }

    const passedDateFromSession = sessionStorage.getItem('selectedRosterDate');
    const passedDate = passedDateFromSession
      ? new Date(passedDateFromSession)
      : new Date();

    passedDate.setHours(9, 55, 0, 0);

    let [startDateTime, endDateTime] = getStartAndEndTime(passedDate);

    if (this.selectedSuggestedRoute?.roster_scheduler?.end_time) {
      // take schedule from the prefilled info
      const preFillSchedule = this.selectedSuggestedRoute?.roster_scheduler;

      startDateTime = new Date(
        (this.selectedSuggestedRoute?.schedule_event_date ||
          preFillSchedule?.start_day) +
          ' ' +
          preFillSchedule?.start_time,
      );

      // check start time is greater than midnight today
      const todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);

      if (startDateTime < todayMidnight) {
        const startDateTimeCopy = new Date(startDateTime);
        startDateTime = new Date();
        startDateTime.setHours(
          startDateTimeCopy.getHours(),
          startDateTimeCopy.getMinutes(),
          0,
          0,
        );
      }

      endDateTime = new Date(
        (this.selectedSuggestedRoute?.schedule_event_date ||
          preFillSchedule?.end_day) +
          ' ' +
          preFillSchedule?.end_time,
      );

      if (endDateTime.getTime() < startDateTime.getTime()) {
        // end time less than start time
        const endDateBackup = new Date(endDateTime);
        endDateTime = new Date();
        endDateTime.setHours(
          endDateBackup.getHours(),
          endDateBackup.getMinutes(),
          0,
          0,
        );
      }
      if (endDateTime.getTime() < startDateTime.getTime()) {
        // overnight cases
        endDateTime.setDate(startDateTime.getDate() + 1);
      }
      if (endDateTime.getTime() < new Date().getTime()) {
        // start and end times have expired for the current day
        endDateTime.setDate(new Date().getDate() + 1);
        startDateTime.setDate(new Date().getDate() + 1);
      }
    }

    this.schedulerForm.controls['repeat_type'].setValue('once');
    this.schedulerForm.controls['end_day'].setValue(
      getFormattedDate(endDateTime),
    );
    this.schedulerForm.controls['end_time'].setValue(
      getFormattedTime(endDateTime),
    );
    this.schedulerForm.controls['end_day'].updateValueAndValidity();
    this.schedulerForm.controls['end_day'].clearAsyncValidators();
    this.schedulerForm.controls['start_day'].setValue(
      getFormattedDate(startDateTime),
    );
    this.schedulerForm.controls['start_time'].setValue(
      getFormattedTime(startDateTime),
    );

    sessionStorage.removeItem('selectedRosterDate');

    this.scheduleStepperActive = true;
    this.getIntervalData();
  }
  saveCurrentSchedule() {
    sessionStorage.setItem(
      btoa('currentSchedule'),
      JSON.stringify(this.schedulerForm.value),
    );
  }
  removeSelectedCP(selectedIndex: number) {
    this.lastAddedCheckpointID = '';
    this.patrolJobType.checkpoints.data =
      this.patrolJobType?.checkpoints?.data?.filter(
        (checkpoint: any, index: number) => index !== selectedIndex,
      );
    if (this.patrolJobType.checkpoints.data.length === 0) {
      // Activate the first tab (All Checkpoints)
      const allCheckpointsTab = document.getElementById('all-checkpoints-tab');
      if (allCheckpointsTab) {
        allCheckpointsTab.click(); // This will select the first tab
      }
    }
  }

  addSelectedCP(addCheckpoint: any) {
    this.lastAddedCheckpointID = '';
    if (this.patrolJobType?.checkpoints?.data?.length < 250) {
      this.patrolJobType?.checkpoints?.data.push(addCheckpoint);
      this.selectedLastCP = addCheckpoint;
      setTimeout(() => {
        this.lastAddedCheckpointID = addCheckpoint?.id;
        const lastElement: any = document.getElementById('lastElementAnchor');
        if (lastElement) {
          lastElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      }, 50);
      if (this.checkpointAddedTimeoutFn)
        clearTimeout(this.checkpointAddedTimeoutFn);
      this.checkpointAddedTimeoutFn = setTimeout(() => {
        this.lastAddedCheckpointID = '';
      }, 1500);
    }
  }

  addAllCheckpoints() {
    this.patrolRouteCPList?.forEach((checkpoint: any) =>
      this.addSelectedCP(checkpoint),
    );
  }
  removeAllCheckpoints() {
    this.patrolJobType.checkpoints.data = [];
    const allCheckpointsTab = document.getElementById('all-checkpoints-tab');
    if (allCheckpointsTab) {
      allCheckpointsTab.click(); // This will select the first tab
    }
  }

  getPatrolRouteCheckpoints(loadMore = false) {
    let params: any = { rows: 10, cursor_based_pagination: 1 };

    if (this.cpSiteFilter?.id) params['site_id'] = this.cpSiteFilter?.id;

    if (this.patrolCpFilterValue?.length > 2) {
      params['search_str'] = this.patrolCpFilterValue;
    }
    if (this.patrolCPCursor) {
      params['next_cursor'] = this.patrolCPCursor;
    }

    this.checkpointService
      .listCheckpointData(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.patrolCPCursor = response?.next_cursor;
          if (loadMore) {
            this.patrolRouteCPList = [
              ...this.patrolRouteCPList,
              ...response?.data,
            ];

            const seen = new Set();

            this.patrolRouteCPList = this.patrolRouteCPList?.filter(
              (item: any) => {
                if (seen.has(item?.id)) return false;
                seen.add(item?.id);
                return true;
              },
            );
          } else {
            this.patrolRouteCPList = response['data'];
          }

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  onLoadMore() {
    this.getPatrolRouteCheckpoints(true);
  }

  onSelectSite(siteData: any) {
    if (siteData?.id !== this.cpSiteFilter?.id) {
      this.cpSiteFilter = siteData;
      this.getFreshCheckpoints();
    }
  }
  getFreshCheckpoints() {
    this.patrolCPCursor = '';

    this.getPatrolRouteCheckpoints();
  }

  searchCheckPoints(event?: any) {
    this.patrolCpFilterValue = event.target.value;
    if (event.target.value?.length > 1) {
      if (this.checkpointSearchTimeoutFn)
        clearTimeout(this.checkpointSearchTimeoutFn);
      this.checkpointSearchTimeoutFn = setTimeout(() => {
        this.getFreshCheckpoints();
      }, 750);
    } else if (!event.target.value?.length) {
      this.patrolRouteCPList = [];
      this.getFreshCheckpoints();
    }
  }

  updateInterval(interval: any) {
    this.intervalCheck = interval;
  }

  uploadFile() {
    var button: any = document.getElementById('fileInput');
    button.click();
  }

  getIntervalData() {
    const scheduleData: any = JSON.parse(
      JSON.stringify(this.schedulerForm.value),
    );

    let diffValue = calculateTimeDifference(scheduleData);
    [this.intervalData, this.welfareReminderDict] =
      getWelfareCheckInterval(diffValue);

    if (!this.intervalData?.length) {
      this.intervalData = [{ name: 'Disabled', value: 0 }];
    }
  }

  handleFileInput(event: any) {
    const allowedFileTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
      'image/avif',
      'image/jpg',
      'image/webp',
    ];
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file?.type?.toLowerCase())) {
      // Process the file (e.g., upload it or display a preview)
      this.patrolJobType.patrol_brief_files.value =
        event?.target?.files.item(0);
    } else {
      // Display an error message or reset the input
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage:
          'Invalid file type selected!, Please choose a PDF or image file.',
      });

      event.target.value = ''; // Reset the file input
    }
  }
  dropCheckPoint(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.patrolJobType?.checkpoints?.data,
      event.previousIndex,
      event.currentIndex,
    );
  }
  getPatroulRouteSuggestions() {
    this.jobService.getPatroulRouteSuggestions().then((response: any) => {
      if (response['status'] == 'success') {
        this.patrolRouteSuggestionsDataList = response?.data;
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  loadSuggestedRoute(routeData: any) {
    this.getAssignees();
    this.getPatrolRouteCheckpoints();
    this.jobService
      .getPatroulRouteSuggestions({}, { route_id: routeData?.id })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSuggestedRoute = response?.data;

          this.formatScheduleForm();
          this.removeAllCheckpoints();
          this.selectedLastCP = null;
          this.formdata.patchValue({
            name: this.selectedSuggestedRoute?.name,

            patrol_brief: this.selectedSuggestedRoute?.patrol_brief,
          });
          this.selectedSuggestedRoute?.check_points?.forEach(
            (checkpoint: any) => this.addSelectedCP(checkpoint),
          );
          this.assignedGuardData = {};
          this.patrolJobType.assignees.data = [];
          let assigneeData: any = {};
          if (this.selectedSuggestedRoute?.subscriber_users?.length) {
            assigneeData = this.selectedSuggestedRoute?.subscriber_users[0];
          }

          this.assigneeList?.forEach((guard: any) => {
            guard.selected = guard?.id === assigneeData?.id;
          });
          if (assigneeData?.id) {
            this.assignedGuardData = assigneeData;

            this.patrolJobType.assignees.data = [assigneeData];
          }
          this.intervalCheck = this.selectedSuggestedRoute?.interval_check;

          this.currentStep = 4;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  selectSuggestedRoute(routeData: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: `Preload tasks from previous patrol?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.loadSuggestedRoute(routeData);
      }
    });
  }
  inputFieldFocused() {
    this.siteListData = JSON.parse(
      JSON.stringify(this.siteListDataBackup || []),
    );
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteListData = res?.data?.splice(0, 10);
          if (!event) {
            this.siteListDataBackup = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  onAssigneeSelect(assignee: any) {
    this.assignedGuardData = { ...assignee };
    this.patrolJobType.assignees.data = [assignee];
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.getAssignees();
    }
  }
  getAssignees(params?: any) {
    this.jobService.getUserList(params).subscribe(async (response: any) => {
      if (response['status'] == 'success') {
        this.assigneeList = [...response?.data];
      }
    });
  }
  editField(field: string) {
    if (field == 'assignee') {
      this.assignedGuardData = {};
      this.getAssignees();
      this.shiftFocus('assigneeId');
    }
  }
}
